export const articles = [
  {
    id: "variety-show-clip",
    title: "综艺剪辑争议：后台片段流传后，舆论为什么一夜反转",
    summary:
      "一段疑似后台交流的片段在网络流传，配合节目正片的时间差，让不少观众对选手评价产生误解。我们把公开信息按顺序排好，看清争议到底从哪一刻开始。",
    categoryId: "ent",
    author: "编辑部 · 林泊",
    date: "2026-09-08",
    readTime: 7,
    views: 28450,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20television%20studio%20with%20soft%20vermilion%20and%20cream%20tones%2C%20abstract%20geometric%20stage%20lights%20and%20timeline%20lines%2C%20magazine%20cover%20aesthetic%2C%20clean%20composition%2C%20high%20detail&width=1200&height=800&seq=bl-art-variety-01&orientation=landscape",
    tags: ["综艺", "剪辑争议", "时间线整理"],
    featured: true,
    evidence: [
      "节目正片公开播出片段（可回看）",
      "节目组官方账号发布的说明文字",
      "多平台同步流传的后台片段，时长约 42 秒",
      "现场观众发布的观演记录（未验证）",
    ],
    timeline: [
      {
        time: "第 1 天 20:00",
        title: "正片播出",
        detail: "节目上线，选手点评片段被剪辑为约 90 秒的连续镜头，观众以为是即时反应。",
      },
      {
        time: "第 2 天 10:30",
        title: "后台片段出现",
        detail: "有账号发布后台交流片段，显示相同对话发生在另一时间点，与正片顺序不同。",
      },
      {
        time: "第 2 天 18:00",
        title: "讨论量快速上升",
        detail: "话题进入热榜，「恶意剪辑」成为主要质疑关键词。",
      },
      {
        time: "第 3 天 12:00",
        title: "节目组回应",
        detail: "节目组发布说明，承认为了叙事节奏调整了镜头顺序，但否认改变原意。",
      },
      {
        time: "第 5 天",
        title: "争议降温",
        detail: "观众讨论转向节目剪辑规范本身，事件热度逐步回落。",
      },
    ],
    content: [
      {
        type: "p",
        text: "综艺节目为了叙事节奏调整镜头顺序，本身是常见的制作手法。真正引发争议的，是当调整后的顺序改变了观众对一句话的理解方向时，节目是否应当作出提示。",
      },
      { type: "h2", text: "争议的起点其实是一次顺序调整" },
      {
        type: "p",
        text: "从公开可回看的正片出发，点评片段被处理成连续镜头，观众自然会认为这是选手当下的即时反应。而后台片段显示，相同内容的交流发生在更早的时间点，中间还隔着一次休息。两个时间点被并置之后，情绪的指向就完全不同了。",
      },
      {
        type: "quote",
        text: "同一句话，放在两个不同的时间点，读者会得出完全相反的结论。",
      },
      { type: "h2", text: "为什么观众反应如此强烈" },
      {
        type: "p",
        text: "观众的不满并非针对剪辑技术本身，而是针对「被引导」的感受。当观众意识到自己是在被安排好的情绪节奏里观看时，对节目的信任会被消耗。这也是为什么讨论很快就从单个选手，转向了对整季剪辑方式的回看。",
      },
      { type: "h3", text: "一个可以复用的判断方法" },
      {
        type: "p",
        text: "遇到类似争议时，不妨先找出正片中镜头切换的位置，再对照流出片段的时长与环境音。如果两者的服装、灯光、现场噪声出现明显差异，基本可以判断存在时间错位。这个方法不依赖任何一方说法，只需要耐心。",
      },
    ],
  },
  {
    id: "livestream-refund-21days",
    title: "直播带货翻车全记录：从第一笔投诉到平台介入的 21 天",
    summary:
      "同一款商品，不同直播间的话术差异明显。我们按时间顺序还原了一位消费者的完整维权路径，并把每一步的有效做法整理出来。",
    categoryId: "rights",
    author: "编辑部 · 周芸",
    date: "2026-09-05",
    readTime: 9,
    views: 41200,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20smartphone%20livestream%20setup%20with%20warm%20amber%20and%20cream%20palette%2C%20abstract%20speech%20bubbles%20and%20parcel%20boxes%2C%20geometric%20shapes%2C%20magazine%20layout%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=bl-art-livestream-02&orientation=landscape",
    tags: ["消费维权", "直播带货", "退款流程"],
    evidence: [
      "订单快照与支付记录",
      "直播间回放中的商品介绍片段",
      "与商家客服的沟通记录",
      "平台介入后的处理进度通知",
    ],
    timeline: [
      {
        time: "第 1 天",
        title: "下单",
        detail: "在直播间下单，主播口播强调「支持七天无理由」。",
      },
      {
        time: "第 4 天",
        title: "收货发现问题",
        detail: "商品与介绍中的规格不一致，联系客服首次提出退货。",
      },
      {
        time: "第 6 天",
        title: "首次被拒",
        detail: "客服以「已拆封」为由拒绝，消费者保留开箱记录。",
      },
      {
        time: "第 12 天",
        title: "提交平台介入",
        detail: "上传订单快照与直播回放片段，申请平台介入。",
      },
      {
        time: "第 21 天",
        title: "退款到账",
        detail: "平台判定责任在商家，全额退款并补偿运费。",
      },
    ],
    content: [
      {
        type: "p",
        text: "直播带货的维权难点，往往不在于规则本身，而在于「证据留在谁手里」。主播的口播内容如果没有被记录下来，事后很难举证。这也是为什么同样的规则，有人三天解决，有人二十天还在拉扯。",
      },
      { type: "h2", text: "第一步永远是保存订单快照" },
      {
        type: "p",
        text: "订单快照会在下单那一刻固定商品标题、规格与价格，是后续所有沟通的基础。很多纠纷之所以难处理，是因为商品详情在事后被修改过，而消费者手上没有任何当时的记录。",
      },
      { type: "h2", text: "直播回放是关键的第二份材料" },
      {
        type: "quote",
        text: "主播说过什么，最好由回放来说，而不是由消费者的记忆来说。",
      },
      {
        type: "p",
        text: "如果平台保留了直播回放，尽快定位到介绍商品的时间点并记下大致时间。若没有回放，退而求其次，可以保存其他观众的录屏或截图，注明来源。",
      },
      { type: "h3", text: "把沟通收敛到一个渠道" },
      {
        type: "p",
        text: "与商家的沟通尽量集中在平台内完成，不要因为着急而转到私人聊天。平台内的记录平台看得到，平台外的记录往往需要额外证明。把每一次沟通的结果简单记一行，时间线会自己浮出来。",
      },
    ],
  },
  {
    id: "restaurant-queue-scene",
    title: "网红餐厅排队 3 小时：现场记录与真实体验的对照",
    summary:
      "社交平台上的探店内容与现场体验差距有多大？我们在同一时段做了多组对照记录，把「看起来很好」和「实际怎么样」分开摆出来。",
    categoryId: "scene",
    author: "编辑部 · 陈屿",
    date: "2026-09-02",
    readTime: 6,
    views: 19870,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20busy%20restaurant%20queue%20with%20warm%20olive%20green%20and%20cream%20tones%2C%20abstract%20waiting%20line%20and%20plate%20shapes%2C%20flat%20geometric%20style%2C%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=bl-art-restaurant-03&orientation=landscape",
    tags: ["探店", "现场实拍", "信息辨别"],
    evidence: [
      "不同时段现场拍摄的环境照片",
      "排队取号截图与叫号记录",
      "同类菜品的实拍与平台图片对照",
      "其他消费者的公开评价",
    ],
    timeline: [
      {
        time: "11:20",
        title: "到店取号",
        detail: "取号显示前方 46 桌，预计等待 150 分钟。",
      },
      {
        time: "12:10",
        title: "第一次对照",
        detail: "平台图片中的空场环境不复存在，实际为满座加等位区。",
      },
      {
        time: "14:35",
        title: "入座",
        detail: "实际等待 195 分钟，超出预计时间约 45 分钟。",
      },
      {
        time: "15:20",
        title: "菜品对照",
        detail: "招牌菜摆盘与平台图片存在分量差异，口味评价两极。",
      },
    ],
    content: [
      {
        type: "p",
        text: "探店内容本身没有问题，问题在于观众常常分不清「内容拍摄环境」和「日常营业环境」。前者经过挑选与安排，后者才是大多数人实际会遇到的场景。",
      },
      { type: "h2", text: "看图片前先看一个细节" },
      {
        type: "p",
        text: "如果一组探店图片中，背景几乎没有其他顾客，而该店又是热门门店，那么这组图片大概率拍摄于非营业时段或经过清场安排。这个判断只需要看背景，不需要任何专业工具。",
      },
      { type: "h2", text: "等待时间往往被低估" },
      {
        type: "quote",
        text: "取号时的预计时间，通常是乐观值；真实等待往往更长。",
      },
      {
        type: "p",
        text: "把预计等待时间上浮三成，是比较稳妥的估算方式。尤其在周末与节假日，翻台速度会明显下降。若时间有限，不如错峰前往，体验会更接近内容里呈现的样子。",
      },
      { type: "h3", text: "把对照变成习惯" },
      {
        type: "p",
        text: "同一道菜，多看几条不同来源的评价，尤其留意近期评价与差评中的具体细节。笼统的「不好吃」参考价值有限，而「分量比图片少三分之一、上菜等了 40 分钟」这类描述，才是真正有用的信息。",
      },
    ],
  },
  {
    id: "layoff-rumor-chat",
    title: "大厂裁员传闻从哪来：一份聊天截图背后的求证过程",
    summary:
      "一张没有出处的聊天截图，如何在两天内变成「行业共识」？我们顺着传播链往回找，看看信息是在哪一步被补上细节的。",
    categoryId: "work",
    author: "编辑部 · 韩知远",
    date: "2026-08-29",
    readTime: 8,
    views: 33900,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20office%20tower%20at%20dusk%20with%20deep%20vermilion%20and%20cream%20tones%2C%20abstract%20chat%20bubble%20shapes%20and%20network%20lines%2C%20geometric%20editorial%20style%2C%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=bl-art-layoff-04&orientation=landscape",
    tags: ["职场", "传闻溯源", "信息辨别"],
    evidence: [
      "最初发布的截图与发布时间",
      "各平台转载版本的差异对照",
      "企业公开招聘信息与官方声明",
      "多位从业者的公开讨论",
    ],
    timeline: [
      {
        time: "第 1 天 21:40",
        title: "截图首次出现",
        detail: "一个匿名账号发布聊天截图，未标注部门与时间。",
      },
      {
        time: "第 2 天 08:00",
        title: "被补充细节",
        detail: "转载版本开始出现具体比例与部门名称，但均无来源。",
      },
      {
        time: "第 2 天 15:00",
        title: "进入热榜",
        detail: "话题热度快速上升，讨论从事实转向情绪。",
      },
      {
        time: "第 3 天",
        title: "出现反向信息",
        detail: "企业公开招聘页面仍显示多个在招岗位，与传闻形成对照。",
      },
    ],
    content: [
      {
        type: "p",
        text: "匿名截图之所以有说服力，是因为它看起来像「内部视角」。但正是这种观看方式，让读者跳过了最基本的一步：确认这张图是谁发的、什么时候发的。",
      },
      { type: "h2", text: "传播中信息是如何被补全的" },
      {
        type: "p",
        text: "最初的截图往往信息很少，只有几句模糊的表述。但在转载过程中，为了让内容更「完整」，具体比例、部门名称会被陆续补充上去。这些补充并非来自原始信源，而是转载者的推测。等到传播链条足够长，推测就变成了看起来确凿的细节。",
      },
      { type: "h2", text: "三个可以马上做的核实动作" },
      {
        type: "p",
        text: "第一，找到最早发布的时间与原图，对比转载版本增加了什么。第二，查看企业公开招聘页面是否有相反信号。第三，搜索是否有从业者的实名公开讨论。三个动作做完，很多传闻的成色就能大致判断。",
      },
      {
        type: "quote",
        text: "当信息越来越具体却没有对应来源时，通常意味着细节是在传播中被『创作』出来的。",
      },
      { type: "h3", text: "情绪传播与事实传播的区别" },
      {
        type: "p",
        text: "事实传播会随着时间变得更清晰，情绪传播则会随着时间变得更激烈。如果你发现同一个话题的讨论，情绪强度在持续上升而新证据几乎没有增加，那就要警惕自己正在参与的是后者。",
      },
    ],
  },
  {
    id: "group-buy-refund-path",
    title: "社区团购爆雷之后：退款的三条路径与各自的时间成本",
    summary:
      "同一场团购纠纷里，不同消费者走上了完全不同的处理路径。我们对比三条路径的实际结果，把时间成本和成功率摊开来说。",
    categoryId: "soc",
    author: "编辑部 · 苏晚",
    date: "2026-08-26",
    readTime: 7,
    views: 26100,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20community%20parcel%20pickup%20point%20with%20warm%20amber%20and%20cream%20palette%2C%20abstract%20boxes%20and%20document%20shapes%2C%20flat%20geometric%20style%2C%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=bl-art-groupbuy-05&orientation=landscape",
    tags: ["社区团购", "退款", "维权路径"],
    evidence: [
      "团购订单与余额截图",
      "团长与平台发布的公告",
      "消费者自主统计的受影响人数",
      "平台客服的书面回复",
    ],
    timeline: [
      {
        time: "第 1 天",
        title: "提现失败",
        detail: "多名用户反馈余额提现失败，平台客服响应变慢。",
      },
      {
        time: "第 3 天",
        title: "团长发布说明",
        detail: "部分团长在群内发布说明，建议用户等待平台处理。",
      },
      {
        time: "第 8 天",
        title: "分头行动",
        detail: "消费者自发分成三条路径：等公告、走客服、集体申诉。",
      },
      {
        time: "第 30 天",
        title: "结果分化",
        detail: "走客服与集体申诉的到账比例明显高于单纯等待。",
      },
    ],
    content: [
      {
        type: "p",
        text: "这类纠纷里，等待本身也是一种选择，而且是成本最高的一种。平台处理资源有限，越早进入明确的处理队列，越可能被优先处理。",
      },
      { type: "h2", text: "路径一：等待平台公告" },
      {
        type: "p",
        text: "成本最低，但不确定性最高。适合金额较小、可以接受等待的情况。需要提醒的是，如果平台持续拖延，等待并不会自动带来结果。",
      },
      { type: "h2", text: "路径二：走平台客服逐笔申诉" },
      {
        type: "quote",
        text: "有记录的处理，比没有记录的处理更快得到回应。",
      },
      {
        type: "p",
        text: "关键在于每一笔都单独提交，并保留受理编号。把多笔合并成一次沟通，反而容易被整体搁置。若客服长时间未回应，注意保留沟通记录与时间点。",
      },
      { type: "h3", text: "路径三：集体申诉" },
      {
        type: "p",
        text: "受影响人数较多时，集体提交同一份材料并注明人数，往往更容易引起重视。材料要包含统一的诉求、受影响清单与每位用户的凭证，避免只提交情绪化描述。",
      },
    ],
  },
  {
    id: "short-video-script-guide",
    title: "短视频「剧本」辨认指南：五个细节就能看出摆拍",
    summary:
      "不是所有看起来像现场的内容都是现场。我们整理了五个可操作的判断细节，帮你在二十秒内判断一条视频的可信度。",
    categoryId: "scene",
    author: "编辑部 · 郑识",
    date: "2026-08-21",
    readTime: 5,
    views: 45600,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20film%20frames%20and%20a%20magnifying%20glass%20with%20vermilion%20and%20cream%20tones%2C%20abstract%20play%20button%20and%20grid%20shapes%2C%20flat%20geometric%20style%2C%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=bl-art-video-06&orientation=landscape",
    tags: ["短视频", "摆拍识别", "媒介素养"],
    evidence: [
      "同一账号的历史内容对比",
      "视频中的环境音与画面细节",
      "评论区中现场目击者的说法",
      "多平台同一素材的不同版本",
    ],
    timeline: [
      {
        time: "第 1 步",
        title: "看镜头位置",
        detail: "摆拍内容常出现恰到好处的机位，仿佛提前知道冲突会发生。",
      },
      {
        time: "第 2 步",
        title: "听环境音",
        detail: "后期配音与现场收音的质感不同，背景人声往往过于均匀。",
      },
      {
        time: "第 3 步",
        title: "看路人反应",
        detail: "真实冲突中路人会回避或围观，而摆拍里的路人常常过于配合。",
      },
    ],
    content: [
      {
        type: "p",
        text: "辨认摆拍不需要专业设备，只需要一点耐心。绝大多数剧本内容会在细节上露出破绽，因为拍摄者需要同时照顾画面、表演和节奏，很难兼顾真实感。",
      },
      { type: "h2", text: "细节一：机位太完美" },
      {
        type: "p",
        text: "真实事件的画面通常是抖动的、构图混乱的。如果一个冲突的镜头稳定、构图完整、恰好拍到关键表情，那么这更像是安排好的。",
      },
      { type: "h2", text: "细节二：时间衔接太顺" },
      {
        type: "quote",
        text: "现实里的冲突有很多空档，剧本里的冲突没有空档。",
      },
      {
        type: "p",
        text: "真实拍摄中，从事件发生到解决往往有大量等待与停顿。如果一段视频里冲突、爆发、结果一气呵成，中间没有任何冗余，那就要多留个心眼。",
      },
      { type: "h3", text: "剩下的三个细节" },
      {
        type: "p",
        text: "第三，看评论区是否有现场目击者提出相反描述；第四，翻该账号历史内容是否大量使用同一套路；第五，搜索同一素材是否在不同账号被包装成不同故事。这三步做完，基本能给出一条视频的可信度区间。",
      },
    ],
  },
  {
    id: "endorsement-contract-clues",
    title: "代言到期不续约：从公开信息能看出哪些合同线索",
    summary:
      "品牌悄悄更换宣传物料、官方账号删除联动内容——这些细节能说明什么，又不能说明什么？我们把能确认的和不能确认的分开讲。",
    categoryId: "ent",
    author: "编辑部 · 林泊",
    date: "2026-08-18",
    readTime: 6,
    views: 22740,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20brand%20billboard%20being%20refreshed%20with%20deep%20vermilion%20and%20cream%20tones%2C%20abstract%20document%20and%20signature%20shapes%2C%20flat%20geometric%20editorial%20style%2C%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=bl-art-brand-07&orientation=landscape",
    tags: ["代言", "合同", "公开信息"],
    evidence: [
      "品牌官网与电商详情页的物料更新",
      "官方账号历史内容的调整",
      "品牌方公开声明（若有）",
      "代言活动的时间记录",
    ],
    timeline: [
      {
        time: "第 1 周",
        title: "物料更换",
        detail: "品牌电商详情页主图由代言人版本更换为产品版本。",
      },
      {
        time: "第 2 周",
        title: "内容调整",
        detail: "官方账号部分联动内容无法访问，引发猜测。",
      },
      {
        time: "第 3 周",
        title: "双方均未回应",
        detail: "品牌与经纪方均未就合作状态作出公开说明。",
      },
    ],
    content: [
      {
        type: "p",
        text: "公开信息能告诉我们「发生了什么变化」，但不能直接告诉我们「变化的原因」。物料更换可能意味着合作到期，也可能只是常规的营销节奏调整。两者之间需要证据来区分。",
      },
      { type: "h2", text: "可以确认的部分" },
      {
        type: "p",
        text: "物料是否更换、更新时间是几点、哪些内容被调整，这些都是客观可查的。把它们按时间排列，就能得到一条清楚的公开变化时间线。",
      },
      { type: "h2", text: "不能直接推断的部分" },
      {
        type: "quote",
        text: "物料更换与合同终止之间，缺少任何一份可以公开验证的文件。",
      },
      {
        type: "p",
        text: "从物料变化直接推断合作关系结束，是一种常见的过度解读。更稳妥的做法，是把这一项列为「待确认」而不是「已确认」。",
      },
      { type: "h3", text: "怎样区分事实与推测" },
      {
        type: "p",
        text: "在整理这类事件时，把每一条信息标注为「公开可查」或「来源不明」。标注本身的动作，就能帮你避免在无意之间把推测当成结论传播出去。",
      },
    ],
  },
  {
    id: "concert-refund-process",
    title: "演唱会退票难：一位观众整理的申诉流程与最终结果",
    summary:
      "临时无法到场，退票却一波三折。这份流程来自一位观众的真实记录，把可复用的部分原样保留下来，供有需要的人参考。",
    categoryId: "rights",
    author: "编辑部 · 周芸",
    date: "2026-08-14",
    readTime: 8,
    views: 30520,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20concert%20venue%20at%20night%20with%20warm%20amber%20and%20cream%20tones%2C%20abstract%20ticket%20and%20spotlight%20shapes%2C%20flat%20geometric%20style%2C%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=bl-art-concert-08&orientation=landscape",
    tags: ["演出票务", "退票", "申诉流程"],
    evidence: [
      "购票订单与出票记录",
      "与票务平台的沟通记录",
      "可佐证的客观情况说明材料",
      "平台与主办方的书面回复",
    ],
    timeline: [
      {
        time: "演出前 9 天",
        title: "提交退票申请",
        detail: "因客观原因无法到场，首次提交退票申请。",
      },
      {
        time: "演出前 7 天",
        title: "被系统驳回",
        detail: "系统以「不支持退换」为由自动驳回，未进入人工审核。",
      },
      {
        time: "演出前 5 天",
        title: "补充材料申诉",
        detail: "整理客观情况说明材料，通过平台人工渠道再次提交。",
      },
      {
        time: "演出后 3 天",
        title: "部分退款到账",
        detail: "平台协调主办方，按票面金额扣除手续费用后退款。",
      },
    ],
    content: [
      {
        type: "p",
        text: "票务退款的难点在于，自动审核系统通常只判断「是否符合规则」，而不判断「是否合理」。所以第一步被驳回，并不代表整件事结束，关键是要把申请从自动审核转到人工审核。",
      },
      { type: "h2", text: "第一步：找到人工入口" },
      {
        type: "p",
        text: "多数平台在自动驳回后都提供人工申诉入口，但入口位置往往不明显。可以在帮助中心搜索「退票申诉」，或通过在线客服连续追问，直到转接人工。",
      },
      { type: "h2", text: "第二步：把材料组织成一份说明" },
      {
        type: "quote",
        text: "把情况写成一页说明，比零散提交十张截图更容易被完整阅读。",
      },
      {
        type: "p",
        text: "说明包含三部分：客观情况、时间证明、明确诉求。诉求要具体，例如「按票面金额扣除合理手续费用后退款」，而不是笼统的「希望处理」。",
      },
      { type: "h3", text: "第三步：给每一次沟通留下编号" },
      {
        type: "p",
        text: "每一次提交都记录时间与受理编号，并在下一次沟通时主动引用。这条时间线既方便自己跟进，也向处理方表明这不是一次临时起意的咨询。",
      },
    ],
  },
];